import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ad-banner-wrapper"
};
export default {
  __name: 'AdsterraNativeBanner',
  setup(__props) {
    // Adsterra Smart Link Component

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("a", {
        href: "https://www.profitablecpmratenetwork.com/p1vum4fv?key=a94900e96f4cf448862d7b498ff9d1e8",
        class: "ad-link",
        target: "_blank",
        rel: "noopener noreferrer"
      }, [_createElementVNode("div", {
        class: "ad-content"
      }, [_createElementVNode("div", {
        class: "ad-text"
      }, "点击了解更多投资实验")])], -1)]))]);
    };
  }
};